import UAParser from 'ua-parser-js';

// @flow
export class DeviceUtil {
  static parser = new UAParser();

  static isIE() {
    const browser = DeviceUtil.parser.getBrowser();

    // console.log(browser);

    if (browser) {
      if (browser.name) {
        return browser.name === 'Internet Explorer' || browser.name === 'IE'
          ? true
          : false;
      }
    }
  }

  static isIOS() {
    const os = DeviceUtil.parser.getBrowser();

    if (os) {
      if (os.name) {
        if (os.name === 'Mobile Safari') {
          return true;
        } else {
          return false;
        }
      }
    }
  }

  static isIOSVersion() {
    const os = DeviceUtil.parser.getBrowser();

    if (os) {
      if (os.major) {
        return os.major;
      }
    }
  }
}
